import React from "react";
import styles from "./SummaryModal.module.css";

interface SummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  errors: string[];
}

const SummaryModal: React.FC<SummaryModalProps> = ({
  isOpen,
  onClose,
  title,
  errors,
}) => {
  const isFirstItemSummary = (item: string) => {
    return (
      item.includes('סה"כ:') &&
      item.includes("הצליח:") &&
      item.includes("נכשל:")
    );
  };

  const isErrorItem = (item: string) => {
    return (item.includes("מספר רכב:") || item.includes("קוד:")) && item.includes(" - ");
  };
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3 className={styles.modalTitle}>{title}</h3>
          <button
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.summaryList}>
            {errors.map((item, index) => {
              const isSummary = isFirstItemSummary(item);
              const isError = isErrorItem(item);

              return (
                <div
                  key={index}
                  className={`${styles.summaryItem} ${
                    isSummary ? styles.success : isError ? styles.error : ""
                  }`}
                >
                  {!isSummary && (
                    <span className={styles.summaryIcon}>
                      {isError ? "⚠️" : "ℹ️"}
                    </span>
                  )}
                  <span
                    className={`${styles.summaryText} ${
                      isSummary ? styles.success : isError ? styles.error : ""
                    }`}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button className={styles.okButton} onClick={onClose}>
            סגור
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryModal;
